<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/corporate-governance',
    'fr-CA': '/relations-avec-investisseurs/gouvernance-entreprise'
  }
})

useHead({
  title: t('navigation.corporateGovernance.metatitle'),
  meta: [{ name: 'description', content: t('navigation.corporateGovernance.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.corporateGovernance.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.corporateGovernance.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <p>KP Tissue Inc. and Kruger Products Inc. are committed to maintaining the highest standards of ethics and governance. To learn more about our governance and ethical values, please see the documents below:</p>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <p>Papiers Tissu KP inc. et Produits Kruger inc. s’engagent à respecter les plus hautes normes d’éthique et de gouvernance. Pour en savoir plus sur leurs valeurs en la matière, veuillez consulter l’information ci-dessous.</p>
          </div>
          <board-directions :title="$t('corporateGouvernance.boardIndependence.title')"
                            :text="$t('corporateGouvernance.boardIndependence.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.mandate.title')"
                            :text="$t('corporateGouvernance.mandate.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.positionDescriptions.title')"
                            :text="$t('corporateGouvernance.positionDescriptions.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.orientation.title')"
                            :text="$t('corporateGouvernance.orientation.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.codeEthics.title')"
                            :text="$t('corporateGouvernance.codeEthics.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.auditCommittee.title')"
                            :text="$t('corporateGouvernance.auditCommittee.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.nominatingCommittee.title')"
                            :text="$t('corporateGouvernance.nominatingCommittee.text')"
                            :txtSee="$t('corporateGouvernance.see')"
                            :txtClose="$t('corporateGouvernance.close')"></board-directions>
          <board-directions :title="$t('corporateGouvernance.other.title')"
                            :text="$t('corporateGouvernance.other.text')"></board-directions>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
